export const numberWithCommas = (num) => {
  if (num > 10000) {
    return (num / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    return num.toString().replace(/\B(?=(\d{2})+(?!\d))/g, '.')
  }
}
